module.exports = __webpack_public_path__ + "static/media/1014962.4c073a57.jpg";